import "./App.css";
import React, { useEffect, useState, Suspense } from "react";
import { BrowserRouter, Route, Routes, useLocation } from "react-router-dom";
import Cssloader from "./_common/cssloader";
import { ThemeProvider } from "./_common/ThemeContext";
import { Provider } from 'react-redux';
import { store, persistor } from "./_store/store";
import DefLoader from "./_common/Loader/DefLoader";
import AuthProvider from "./_common/AuthProvider";
import { PersistGate } from "redux-persist/integration/react";
import AlertMessage from "./_webapp/CommonComponents/AlertMessage/AlertMessage";
// import { initGoogleAnalytics, trackPageView } from "./_utils/analytics";

// Lazy load all route components for code splitting
const Home = React.lazy(() => import("./_webapp/_Pages/Home/Home"));
const Login = React.lazy(() => import("./_webapp/_Pages/Login/Login"));
const ContactUs = React.lazy(() => import("./_webapp/_Pages/ContactUs/ContactUs"));
const Terms = React.lazy(() => import("./_webapp/_Pages/Terms/Terms"));
const Privacy = React.lazy(() => import("./_webapp/_Pages/Privacy/Privacy"));
const Practice = React.lazy(() => import("./_webapp/_Pages/Practice/Practice"));
const Subscription = React.lazy(() => import("./_webapp/_Pages/Subscription/Subscription"));
const RefernEarn = React.lazy(() => import("./_webapp/_Pages/RefernEarn/RefernEarn"));
const Profile = React.lazy(() => import("./_webapp/_Pages/Profile/Profile"));
const QuestionDetail = React.lazy(() => import("./_webapp/_Pages/QuestionDetail.jsx/QuestionDetail"));
const BoltCoinStore = React.lazy(() => import("./_webapp/_Pages/BoltCoinStore/BoltCoinStore"));
const QuizListing = React.lazy(() => import("./_webapp/_Pages/QuizListing/QuizListing"));
const TestSeries = React.lazy(() => import("./_webapp/_Pages/TestSeries/TestSeries"));
const TestSeriesPage = React.lazy(() => import("./_webapp/_Pages/TestSeriesPage/TestSeriesPage"));
const Logout = React.lazy(() => import("./_webapp/CommonComponents/Logout/Logout"));
const QuizDetail = React.lazy(() => import("./_webapp/_Pages/QuizDetail/QuizDetail"));
const QuizPage = React.lazy(() => import("./_webapp/_Pages/QuizPage/QuizPage"));
const QuizLeaderboard = React.lazy(() => import("./_webapp/_Pages/QuizLeaderboard/QuizLeaderboard"));
const QuizAnswerKey = React.lazy(() => import("./_webapp/_Pages/QuizAnswerKey/QuizAnswerKey"));
const TestSeriesDetail = React.lazy(() => import("./_webapp/_Pages/TestSeriesDetail/TestSeriesDetail"));

// Loading component for Suspense fallback
const LoadingFallback = () => (
  
  <div style={{ 
    display: 'flex', 
    justifyContent: 'center', 
    alignItems: 'center', 
    height: '200px',
    fontSize: '16px',
    color: '#666'
  }}>
    
  </div>
);
const Analytics = () => {
  const location = useLocation();

  // useEffect(() => {
  //   trackPageView(location.pathname);
  // }, [location]);

  return null;
};
function App() {
  // useEffect(() => {
  //   initGoogleAnalytics();
  // }, []);
  return (
    <ThemeProvider>
      <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
          <div className="App">
            <DefLoader />
            <AlertMessage />
            <Cssloader />
            <BrowserRouter>
              <Analytics />
              <Suspense fallback={<LoadingFallback />}>
                <Routes>
                  <Route path={"/"} element={<Home />} exact />
                  <Route path={"/:category/:subCategory/:question/:id"} element={<QuestionDetail />} />
                  <Route path={"/accounts/login"} element={<Login />} exact />
                  <Route path={"/contact-us"} element={<ContactUs />} exact />
                  <Route path={"/quiz-listing"} element={<QuizListing />} exact />
                  <Route path={"/terms-and-conditions"} element={<Terms />} exact />
                  <Route path={"/privacy-policy"} element={<Privacy />} exact />
                  <Route path={"/practice"} element={<Practice />} exact />
                  <Route path={"/test-series"} element={<TestSeries />} exact />
                  <Route path={"/pricing"} element={<Subscription />} exact />
                  <Route path={"/test-series/:category/:description/:id"} element={<TestSeriesDetail />} exact />
                  <Route path={"/refer-n-earn"} element={<RefernEarn />} exact />
                  <Route path={"/logout"} element={<Logout />} exact />

                  {/* Protected Routes */}
                  <Route element={<AuthProvider />}> 
                    <Route path={"/accounts/profile"} element={<Profile />} exact />
                    <Route path={"/store"} element={<BoltCoinStore />} exact />
                    <Route path={"/test-series/:topic/:id"} element={<TestSeriesPage />} exact />
                    <Route path={"/quiz-detail/:id"} element={<QuizDetail />} exact />
                    <Route path={"/quiz/:id"} element={<QuizPage />} exact />
                    <Route path={"/quiz-leaderboard/:id"} element={<QuizLeaderboard />} exact />
                    <Route path={"/quiz-answer-key/:id"} element={<QuizAnswerKey />} exact />
                  </Route>
                </Routes>
              </Suspense>
            </BrowserRouter>
          </div>
        </PersistGate>
      </Provider>
    </ThemeProvider>
  );
}

export default App;